import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { HttpErrorResponse } from '@angular/common/http';
import { LoginResposne } from 'src/app/models/login-response.model';
import { of, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SigninService {

  constructor(
    private userService: UserService,
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService,
  ) { }

  authorizeUser(credentials: any): Observable<{ status: number; message: string }> {
    console.log("jhjjh")
    return this.userService.authorizeUser(credentials).pipe(
      map((data: any) => {
        if (data.newPasswordRequired) {
          this.router.navigate(['/password-help'], {
            queryParams: { email: data.email },
          });
          const message = 'Your password has expired, please reset your password.';
          this.toastr.success(message, '', {
            positionClass: 'toast-top-center',
            closeButton: false,
            timeOut: 4500,
          });
          return { status: 409, message };
        } else {
          this.authService.storeAccessToken(data.token);
          this.authService.storeUserId(data.id);
          return { status: 200, message: 'Login successful' };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 402) {
          console.log('Subscription expired error:', error.error.data);
          var message = "";
          var toasterMessage = "";
          if (error.error.data && error.error.data.CognitoGroupNotAssigned) {
            toasterMessage = 'Please take a moment to update your credentials to stay connected.';
            message = 'A Better Experience Awaits.We’ve made improvements behind the scenes and upgraded your access. Please take a moment to update your credentials to stay connected.';
          } else {
            toasterMessage = 'Your plan has expired. Please update to continue the access.';
            message = 'Your plan has expired. Please update to continue the access.';
          }

          this.toastr.success(toasterMessage, '', {
            positionClass: 'toast-top-center',
            closeButton: false,
          });
          return of({ status: 402, message });
        } else {
          const message = error.error?.error?.message ?? 'Unexpected error';
          return of({ status: error.status || 500, message });
        }
      })
    );
  }
  getUserDetailsAndRedirect(): Observable<{ status: number; message: string }> {
    return this.userService.getUserDetails().pipe(
      map((data) => {
        this.authService.storeUserEmail(data.email);
        this.authService.storeUserId(data.id);
        this.authService.storeUserName(data.firstName);
        this.authService.storeUserAvatar(data.avatarPath ?? null);
        this.authService.storeUserPermissions(JSON.stringify(data.permissionsMap) ?? null);
        this.authService.storeUserData(JSON.stringify(data) ?? null);
        this.userService.updateUserData(data);

        if (data.skipOnboarding != null && data.skipOnboarding === false) {
          this.router.navigate(['/onboarding']);
        } else {
          this.router.navigate(['/dashboard/explore']).then(() => {
            history.replaceState(null, '', '/dashboard/explore');
          });
        }

        return { status: 200, message: 'User details loaded successfully' };
      }),
      catchError((error: HttpErrorResponse) => {
        this.authService.clearStorage();
        const message = error.error?.error?.message ?? 'Failed to load user details';
        this.toastr.error(message);

        return of({ status: error.status || 500, message });
      })
    );
  }

}
